// 获取IE版本
export const getIEVersion = () => {
    // 取得浏览器的userAgent字符串
    const userAgent = navigator.userAgent
    // 判断是否为小于IE11的浏览器
    const isLessIE11 = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1
    // 判断是否为IE的Edge浏览器
    const isEdge = userAgent.indexOf('Edge') > -1 && !isLessIE11
    // 判断是否为IE11浏览器
    const isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1
    if (isLessIE11) {
        // eslint-disable-next-line prefer-regex-literals
        const IEReg = new RegExp('MSIE (\\d+\\.\\d+);')
        // 正则表达式匹配浏览器的userAgent字符串中MSIE后的数字部分，，这一步不可省略！！！
        IEReg.test(userAgent)
        // 取正则表达式中第一个小括号里匹配到的值
        const IEVersionNum = parseFloat(RegExp['$1'])
        if (IEVersionNum === 7) {
            // IE7
            return 7
        } else if (IEVersionNum === 8) {
            // IE8
            return 8
        } else if (IEVersionNum === 9) {
            // IE9
            return 9
        } else if (IEVersionNum === 10) {
            // IE10
            return 10
        } else {
            // IE版本<7
            return 6
        }
    } else if (isEdge) {
        // edge
        return 'edge'
    } else if (isIE11) {
        // IE11
        return 11
    } else {
        // 不是ie浏览器
        return -1
    }
}

export const isIE = () => {
    return !!window.ActiveXObject || 'ActiveXObject' in window
}

/*
 * 判断两个版本号的大小
 * 两个版本号的字符串
 * 1 表示第一个版本号大于第二个
 * 0 表示两个版本号相同
 *  -1 表示第一个版本号小于第二个
 */
export function compareVersion(v1, v2) {
    const arrV1 = v1.split('.')
    const arrV2 = v2.split('.')

    for (let i = 0; i < arrV1.length && i < arrV2.length; i++) {
        if (parseInt(arrV1[i]) > parseInt(arrV2[i])) return 1
        else if (parseInt(arrV1[i]) < parseInt(arrV2[i])) return -1
    }
    if (arrV1.length === arrV2.length) {
        return 0
    } else if (arrV1.length > arrV2.length) {
        return 1
    } else {
        if (arrV1.length === 2 && arrV1[1] === 0) {
            return 1
        } else {
            return -1
        }
    }
}
